import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'

export const refreshSummaryTab = () =>
  detailsPanelStore.setState((s) => ({ ...s, keyForRefreshingSummaryTab: new Date().toISOString() }))
